//
import React, { useEffect, useLayoutEffect, useState } from 'react';
import '../css/menu.css';
import { useNavigate } from 'react-router-dom';
import { useAPICall } from '../hooks/useAPICall';

let menuopen = false;

export function MenuForm() {


  const [menuData, setMenuData] = useState([]);

  const handleDataFetch = (data) => {
    setMenuData(data.components['menu'].menus);
  }
  const { MakeCall } = useAPICall();

  useEffect(() => {
    MakeCall('menu/getmenu', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\"}", handleDataFetch);
    window.addEventListener('click', function (e) {
      let el = document.getElementById('mobilewrapper');
      if(el)
      {
      if (el.contains(e.target)) {
          // Clicked in box
      } else {
    
        handleCloseMenu();
        
      }
  }
  });
  });

  useLayoutEffect(() => {
    function updateSize() {
      handleCloseMenu();
    }
    window.addEventListener('resize', updateSize);
    updateSize();
  });

  function handleCloseMenu() {
    menuopen = false;
    document.getElementById("menubox").style.display = 'none';

  }


  return (
    <>
      {RenderMenu(menuData)}
    </>
  );


}

function RenderMenu(menus) {
  const navigate = useNavigate();

  function handleNav(destination) {

    navigate(destination);
  }
  function handleShowMenu() {
    if (!menuopen) {
      document.getElementById("menubox").style.display = 'block';


    }
    else {
      document.getElementById("menubox").style.display = 'none';
    }
    menuopen = !menuopen;
  }

  function handleJSNav(newurl)
  {
    window.open(newurl, '_blank');
    //window.location.href = newurl;
  }

  return (

    <div className='menubase'>
      <div className='mobile-menu-wrapper' id='mobilewrapper'>

        <div className='mainmenu-mobile'>
          <div style={{"display":"block", "width":"100%"}}>
          <div style={{"display":"flex", "width":"100%"}}>
            <div className='mobilemenulogo'><img className='menulogo' src='imgs/PRC_LOGO.png' alt='Menu'></img></div>
            <div className='menuicondiv' onClick={handleShowMenu}><img className='menuicon' src='imgs/menuicon.png' alt='Menu'></img></div>
          </div>
          <div>
          <div className='mainmenu-popout' id='menubox'>
            {menus.map((page) => (
              <div key={page.menu_name} className='mobilemenubarbutton' onClick={() => { handleNav(page.navigation) }}>
                {page.menu_name}
              </div>
            ))}
             <div key='privacy' className='mobilemenubarbutton' onClick={() => { handleJSNav('https://www.peverilrifleclub.im/gdpr/') }}>
                Privacy
              </div>
          </div>
          </div>
        </div>
        </div>


      </div>
      <div className='desktop-menu-wrapper'>
        <div className='mainmenu'>
          <div className='menulogo'><img className='menulogo' src='imgs/PRC_LOGO.png' alt='Menu'></img></div>
          {menus.map((page) => (
            <div key={page.menu_name} className='menubarbutton' onClick={() => { handleNav(page.navigation) }}>
              {page.menu_name}
            </div>
          ))}
            <div key='privacy' className='menubarbutton' onClick={() => { handleJSNav('https://www.peverilrifleclub.im/gdpr/') }}>
                Privacy
              </div>
        </div>
      </div>
    </div>

  );
}








